import React, { useState } from 'react'
import "../CSS/Experience2.css"
import ab1 from "../Images/pf.png"
import ab2 from "../Images/bs.png"
import ab3 from "../Images/fe.png"
import ab4 from "../Images/costech.png"
import ab5 from "../Images/teconOil.png"
import ab6 from "../Images/mission.jpeg"
import ab7 from "../Images/alues.jpeg"

const Experience2 = () => {
    const [menuSwitch,setMenuSwitch]=useState(0)
  return (
    <div className='Experience2' id="experience">
        
        <h1>EXPERIENCES</h1>
        {/* <p style={{color:"green",fontWeight:"bold",textDecoration:"underline"}}>About Us</p> */}
      <div className='Experience2Body'>
      <div className='Experience2SideBar'>
        <p className={menuSwitch===0?"Experience2SideBarMenuActive":'Experience2SideBarMenu'} onClick={()=>setMenuSwitch(0)}>BIM STRUCTURAL ENGINEER</p>
        <p className={menuSwitch===1?"Experience2SideBarMenuActive":'Experience2SideBarMenu'} onClick={()=>setMenuSwitch(1)}>PROJECT ENGINEER / BIM DIRECTOR</p>
        <p className={menuSwitch===2?"Experience2SideBarMenuActive":'Experience2SideBarMenu'} onClick={()=>setMenuSwitch(2)}>TECHNICAL ASSISTANT (MD)</p>
        <p className={menuSwitch===3?"Experience2SideBarMenuActive":'Experience2SideBarMenu'} onClick={()=>setMenuSwitch(3)}>FACILITATOR (IT SUPPORT & CAD TRAINING)</p>
        <p className={menuSwitch===4?"Experience2SideBarMenuActive":'Experience2SideBarMenu'} onClick={()=>setMenuSwitch(4)}>FIELD SUPPORT / JAM TECHNICIAN</p>
        {/* <p className={menuSwitch===5?"Experience2SideBarMenuActive":'Experience2SideBarMenu'} onClick={()=>setMenuSwitch(5)}>OUR MISION</p> */}
        {/* <p className={menuSwitch===6?"Experience2SideBarMenuActive":'Experience2SideBarMenu'} onClick={()=>setMenuSwitch(6)}>CORE VALUES</p> */}
      </div>
      <div className='Experience2Content'>
        {menuSwitch===0&&<div className='ContentA'>

            <h2>BIM Structural Engineer</h2>
            <p>Pernix Federal LLC Nigeria Limited, Lagos </p>
            <p>2023 May – Current</p>
            <p style={{color:"blue"}}> New United State Of American. Consulate Compound Lagos Nigeria</p>
            <img src={ab1} alt="ab"/>
            <p style={{textAlign:"left"}}>o Preparing coordination drawings wrt MEP models<br/>
o Prepare RFDC / RFI when need arises.<br/>
o Update Revit BIM models as per designer’s response to RFDC.<br/>
o Support the site team on model clarifications and drawings.<br/>
o Develop workflow for topo levels from civil 3d to Revit model.<br/>
o Maintain and update Naviswork models </p>
        </div>}

        {menuSwitch===1&&<div className='ContentA'>

            <h2>Project Engineer / BIM Director</h2>
            <p>Buildsafe Nigeria Limited, Lagos</p>
            <p>2019 Jan – 2023 May</p>
            <img src={ab2} alt="ab"/>
            <p style={{textAlign:"left"}}> Structural Restoration of 20m roof canopy loading bay for Seven Up 
Bottling Company.<br/>
  Structural design of Warehouse building of Highspeed PETLINE for 
Nigerian Bottling CompanyIkeja<br/>
  Site restoration and development or Nigerian Bottling Company Ikeja<br/>
  As-built Model of oil refinery storage tank for DOMALONG (SCAN TO 
BIM PROJECT) <br/>
 Structural and Drainage Appraisal of AG-Leventis House for Sanni Ojo 
& Partners Consulting Limited <br/>
 Flood management and Control For Africa-works Co-working Limited 
Lagos   <br/>
 As-built Model and Detail Survey of Nigerian Bottling CompanyIkeja 
Plant, 11 Hectares (SCAN TO BIM PROJECT)<br/>
  As-built Model and Detail Survey of Nigerian Bottling 
CompanyBeninPlant, 7 Hectares.(SCAN TO BIM PROJECT) <br/>
 2440sqm Warehouse design and execution for Nigerian Bottling 
CompanyPlant Owerri.<br/>
  Air Handling Unit platform design for Nigerian Bottling Company 
Owerri Plant and Benin Plant.<br/>
  Depot Site development for Nigerian Bottling Company Yola, 6Hectares<br/>
   As-built Model of Capital Centrum for Julius Berger. (SCAN TO BIM 
PROJECT)<br/>
  Development of 17Hectares Tile Manufacturing Factory using BIM 
processes at Shagam from concept to construction.<br/>
  Development of master Plan for Lagos Mega City as Pilot Project.<br/>
   In-house training on BIM processes and best recommended designwork 
flow. Interoperability of all BIM tools on all project.<br/>
  Erosion control and flood management research for NEWMAP 
OWERRI</p>

<h1>ACHIEVMENTS</h1>
<p style={{textAlign:"left"}}> I have used civil 3d to generate the actual earth work material of about 7000cum net fill as against 
15000cum claim from contractor.<br/> 
 Using arcmap and Google earth pro to study and advice client on prospective Landed property for 
procurement. <br/><br/>
 Creating of Revit family elements such as:<br/> 
1. parametric line drain with all features variables.<br/> 
2. parametric slab <br/><br/>
 Training of 7 young engineers on BIM workflow recommended best practices. <br/>
 During COVID 19 Lock down, I coordinated all project design team remotely using BIM 360 </p>             </div>}

             {menuSwitch===2&&<div className='ContentA'>

<h2>TECHNICAL ASSISTANT (MD)</h2>
<p>Fareast Mercantile Company Limited, Lagos 
</p>
<p>2018 May – 2019 January</p>
<img src={ab3} alt="ab"/>
<p style={{textAlign:"left"}}> Project coordinator for Quaker Oat PepsiCo factory at Kopek Road, Mushin Lagos. <br/>
 Have successfully modeled a TIN production plant using 3D Autodesk Inventor. <br/>
 Planning Business Unit monthly meeting across the company four branches <br/>
 Having spotted more than 50 noncompliance issues in the factory that are undergoing resolutions. </p>
 
 
 </div>}
 {menuSwitch===3&&<div className='ContentA'>

<h2>Facilitator (IT Support and CAD Training) 
</h2>
<p>Costech CAD Consult Limited, Lagos </p>
<p>2017 June – 2018 Feb</p>
<img src={ab4} alt="ab"/>
<p style={{textAlign:"left"}}> Uses computer-aided design and structural analysis software to develop drawing plans for 
Architecture, Engineering, Construction and manufacturing industries. <br/>
 I have successfully trained more than 20 clients in engineering design software.</p>
 
 
 </div>}

 {menuSwitch===4&&<div className='ContentA'>

<h2> Field Supervisor/Jam Technician 
</h2>
<p>Tecon Oil Services Nigeria Limited Portharcourt</p>
<p>2014 March – 2015 Oct</p>
<img src={ab5} alt="ab"/>
<p style={{textAlign:"left"}}> Involve in casing of oil well for Shell, AGIP, Exxon Mobil, NPDC. <br/>
 Operate JAM Unit system for Torque Tong during Oil well completions. <br/>
 Design and Plan for Equipment Load Outs during Call Out for Rig operation</p>
 
 
 </div>}

 {menuSwitch===5&&<div className='ContentA'>

<h2>OUR MISION</h2>
<img src={ab6} alt="ab"/>
<p>To provide services, programmes and products of finest quality to serve the best interest of clients and consumers of our products and services.</p>
 
 
 </div>}

 {menuSwitch===6&&<div className='ContentA'>

<h2>CORE VALUES</h2>
<img src={ab7} alt="ab"/>
<p>We are a company seeking to provide services, programmes and products of finest quality to our clients and stakeholders. In doing so, we believe in core values which includes honesty, truthfulness, unity and teamwork. Our company is guided by these laid down organizational values that guides the delivery of services by staff. We believe in producing Finest Quality.</p>
 
 
 </div>}
 
      </div>
      </div>
    </div>
  )
}

export default Experience2
